import './App.css'
import RowsComponent from './components/RowsComponent'
import GuessComponent from './components/GuessComponent'
import FlagImageComponent from './components/FlagImageComponent'
import { startingBoard } from "./domains/Board"
import { countryList } from "./domains/CountryList"
import { createContext, useEffect, useState } from "react"
import { gameOver } from './domains/GameEnd'
import GameOverComponent from './components/GameOverComponent'
import HintComponent from './components/HintComponent'

//used to give access to this on other components.
export const AppContext = createContext()

function App() {

  const [rows, setRows] = useState(startingBoard)
  const [countries] = useState(countryList)
  const [currAttempt, setCurrAttempt] = useState(0)
  const [chosenCountry, setChosenCountry] = useState("")
  const [gameStatus, setGameStatus] = useState(gameOver)
  const [modalOpen, setModalOpen] = useState(false)
  const [hintModalOpen, setHintModalOpen] = useState(false)

  //the very first time this method runs, fetch the random country to guess
  useEffect(() => {
    let randomNum = Math.floor(Math.random() * countries.length)
    setChosenCountry(countries[randomNum])
  }, [countries])

  //anything inside the AppContext.Provider tag will be given the AppContext variable declared above (used to prevent passing a bunch of props to multiple components).
  return (
    <div className="App">
      <nav>
        <h1>Flagle</h1>
      </nav>

      <div className="game">

        {modalOpen &&
          <GameOverComponent
            setOpenModal={setModalOpen}
            gameEnd={gameStatus}
            country={chosenCountry}
          />}

        {hintModalOpen &&
          <HintComponent
            setOpenModal={setHintModalOpen}
            country={chosenCountry}
          />}

        <FlagImageComponent
          country={chosenCountry}
        />

        <AppContext.Provider
          value={{ rows, setRows, currAttempt, setCurrAttempt, chosenCountry, countries, gameStatus, setGameStatus, setModalOpen, setHintModalOpen }}>
          <RowsComponent />
          <GuessComponent />
        </AppContext.Provider>
      </div>
    </div>
  )
}

export default App
